// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EtKy","label":"styles_label__1tXg7"};